import React from 'react';
import PropTypes from 'prop-types';

import { Title } from './css';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ErrorMessages = ({ error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING },
        labels: { FORGOT_PASSWORD_PAGE_TITLE }
      }
    }
  } = localizedStrings;

  return (
    <>
      <h2>
        <div id="main-content-title">
          <Title>{FORGOT_PASSWORD_PAGE_TITLE}</Title>
        </div>
      </h2>
      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{GENERIC_ERROR_HEADING}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

ErrorMessages.propTypes = {
  error: PropTypes.bool.isRequired
};
export default ErrorMessages;
